import type { Template } from "@/types";

export const SQ_07_H5_V2: Template[] = [
    {
        id: "sq-07-h5v2-01",
        name: "SQ 01 - H5V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h5_v2_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 93, y: 85, width: 261, height: 177, rotation: 0, imageRotation: 0 },
            { id: "2", x: 93, y: 270, width: 261, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 93, y: 455, width: 261, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 362, y: 85, width: 262, height: 547, rotation: 0, imageRotation: 0 },
            { id: "5", x: 807, y: 157, width: 264, height: 197, rotation: 0, imageRotation: 0 },
            { id: "6", x: 807, y: 362, width: 264, height: 197, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1079, y: 157, width: 265, height: 402, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "sq-07-h5v2-02",
        name: "SQ 02 - H5V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h5_v2_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 90, y: 157, width: 265, height: 198, rotation: 0, imageRotation: 0 },
            { id: "2", x: 90, y: 363, width: 265, height: 197, rotation: 0, imageRotation: 0 },
            { id: "3", x: 362, y: 157, width: 266, height: 403, rotation: 0, imageRotation: 0 },
            { id: "4", x: 810, y: 85, width: 262, height: 177, rotation: 0, imageRotation: 0 },
            { id: "5", x: 810, y: 270, width: 262, height: 177, rotation: 0, imageRotation: 0 },
            { id: "6", x: 810, y: 455, width: 262, height: 177, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 85, width: 262, height: 547, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-07-h5v2-03",
        name: "SQ 03 - H5V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h5_v2_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 93, y: 85, width: 261, height: 177, rotation: 0, imageRotation: 0 },
            { id: "2", x: 93, y: 270, width: 261, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 93, y: 455, width: 261, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 362, y: 85, width: 262, height: 547, rotation: 0, imageRotation: 0 },
            { id: "5", x: 802, y: 85, width: 547, height: 271, rotation: 0, imageRotation: 0 },
            { id: "6", x: 802, y: 363, width: 362, height: 269, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1172, y: 363, width: 177, height: 269, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h5v2-04",
        name: "SQ 04 - H5V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h5_v2_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 93, y: 85, width: 531, height: 414, rotation: 0, imageRotation: 0 },
            { id: "2", x: 93, y: 507, width: 172, height: 125, rotation: 0, imageRotation: 0 },
            { id: "3", x: 273, y: 507, width: 172, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 453, y: 507, width: 171, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 781, y: 471, width: 240, height: 161, rotation: 0, imageRotation: 0 },
            { id: "6", x: 781, y: 85, width: 240, height: 378, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1029, y: 85, width: 336, height: 547, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h5v2-05",
        name: "SQ 05 - H5V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h5_v2_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 83, y: 96, width: 551, height: 327, rotation: 0, imageRotation: 0 },
            { id: "2", x: 83, y: 431, width: 132, height: 190, rotation: 0, imageRotation: 0 },
            { id: "3", x: 221, y: 431, width: 275, height: 190, rotation: 0, imageRotation: 0 },
            { id: "4", x: 502, y: 431, width: 132, height: 190, rotation: 0, imageRotation: 0 },
            { id: "5", x: 800, y: 273, width: 551, height: 348, rotation: 0, imageRotation: 0 },
            { id: "6", x: 800, y: 96, width: 272, height: 170, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 96, width: 272, height: 170, rotation: 0, imageRotation: 0 }
          
           
        ],
    },

    {
        id: "sq-07-h5v2-06",
        name: "SQ 06 - H5V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h5_v2_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 82, y: 85, width: 315, height: 547, rotation: 0, imageRotation: 0 },
            { id: "2", x: 405, y: 85, width: 225, height: 154, rotation: 0, imageRotation: 0 },
            { id: "3", x: 405, y: 247, width: 225, height: 385, rotation: 0, imageRotation: 0 },
            { id: "4", x: 802, y: 136, width: 547, height: 312, rotation: 0, imageRotation: 0 },
            { id: "5", x: 802, y: 455, width: 177, height: 127, rotation: 0, imageRotation: 0 },
            { id: "6", x: 987, y: 455, width: 177, height: 127, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1172, y: 455, width: 177, height: 127, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h5v2-07",
        name: "SQ 07 - H5V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h5_v2_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 35, y: 36, width: 678, height: 427, rotation: 0, imageRotation: 0 },
            { id: "2", x: 721, y: 36, width: 335, height: 427, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1064, y: 36, width: 335, height: 427, rotation: 0, imageRotation: 0 },
            { id: "4", x: 35, y: 471, width: 335, height: 209, rotation: 0, imageRotation: 0 },
            { id: "5", x: 378, y: 471, width: 335, height: 209, rotation: 0, imageRotation: 0 },
            { id: "6", x: 721, y: 471, width: 335, height: 209, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1064, y: 471, width: 335, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h5v2-08",
        name: "SQ 08 - H5V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h5_v2_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 134, width: 641, height: 449, rotation: 0, imageRotation: 0 },
            { id: "2", x: 649, y: 134, width: 151, height: 225, rotation: 0, imageRotation: 0 },
            { id: "3", x: 649, y: 367, width: 309, height: 216, rotation: 0, imageRotation: 0 },
            { id: "4", x: 966, y: 367, width: 310, height: 216, rotation: 0, imageRotation: 0 },
            { id: "5", x: 808, y: 134, width: 309, height: 225, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1125, y: 134, width: 309, height: 225, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1283, y: 366, width: 151, height: 216, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h5v2-09",
        name: "SQ 09 - H5V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h5_v2_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 84, width: 238, height: 178, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 270, width: 238, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 455, width: 238, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 246, y: 84, width: 362, height: 548, rotation: 0, imageRotation: 0 },
            { id: "5", x: 616, y: 84, width: 422, height: 270, rotation: 0, imageRotation: 0 },
            { id: "6", x: 616, y: 362, width: 422, height: 270, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1046, y: 84, width: 388, height: 548, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h5v2-10",
        name: "SQ 10 - H5V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h5_v2_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 55, width: 979, height: 606, rotation: 0, imageRotation: 0 },
            { id: "2", x: 987, y: 55, width: 220, height: 299, rotation: 0, imageRotation: 0 },
            { id: "3", x: 987, y: 362, width: 220, height: 299, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1215, y: 55, width: 219, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1215, y: 209, width: 219, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1215, y: 363, width: 219, height: 145, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1215, y: 516, width: 219, height: 145, rotation: 0, imageRotation: 0 }
        ],
    },
];
